import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface FooterDocument {
  id: number;
  section: string;
  name: string;
  url: string;
}

export interface FinanceLink {
  id: number;
  name: string;
  url: string;
}

export interface FinanceGroup {
  id: number;
  title: string;
  links: FinanceLink[];
}

export interface FinanceSection {
  id: number;
  title: string;
  groups: FinanceGroup[];
}

export interface LegalPage {
  slug: string;
  title: string;
  contentHtml: string;
}

interface GeneralResponse<T> {
  Info: string;
  MessageError: string;
  Data: T;
}

@Injectable({
  providedIn: 'root'
})
export class FooterContentService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/footer-content`;

  getDocuments(section: string): Observable<FooterDocument[]> {
    return this.http
      .get<GeneralResponse<FooterDocument[]>>(`${this.baseUrl}/documents`, {
        params: { section }
      })
      .pipe(map((res) => res.Data ?? []));
  }

  getFinance(): Observable<FinanceSection[]> {
    return this.http
      .get<GeneralResponse<FinanceSection[]>>(`${this.baseUrl}/finance`)
      .pipe(map((res) => res.Data ?? []));
  }

  getLegalPage(slug: string): Observable<LegalPage> {
    return this.http
      .get<GeneralResponse<LegalPage>>(`${this.baseUrl}/legal/${slug}`)
      .pipe(map((res) => res.Data));
  }
}
